<div *ngIf="lessonStatus === 'STARTED'" style="width:100%; height:100vh;">
  <iframe
    [src]="iframeUrl | safeUrl"
    width="100%"
    height="100%"
    frameborder="0">
  </iframe>
</div>

<div *ngIf="lessonStatus == 'EXPIRED'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd;">Session Expired</h1>
    </div>
</div>

<div *ngIf="lessonStatus == 'YET_TO_START'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd;">Session Not Started Yet</h1>
    </div>
</div>

<div *ngIf="lessonStatus == 'INVALID'" class="status-text-style">
    <div class="centerd">
        <h1 style="color:#47defd;">Invalid Lesson</h1>
    </div>
</div>